import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { deleteServiceLocation } from 'src/store/actions/service-location-actions';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { IServiceLocation } from 'src/types/service-locations';

interface Props {
    data: IServiceLocation;
}

const DeleteServiceLocationAction: React.FunctionComponent<Props> = ({ data: { id, title } }: Props) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const handleClose = () => {
        setOpened(false);
    };

    /* eslint-disable */
    /* eslint jsx-a11y/anchor-is-valid: 0 */
    /* eslint-enable */
    return (
        <>
            <button type="button" onClick={() => setOpened(true)} className="btn btn-secondary">
                <FontAwesomeIcon icon={faTrash} />
            </button>
            <Modal show={opened} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete {`"${title}"`}?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() =>
                            dispatch(
                                deleteServiceLocation(
                                    id,
                                    () => {
                                        handleClose();
                                        toast.success('Service Location was successfully deleted.');
                                    },
                                    (errorMessage: string) => {
                                        handleClose();
                                        toast.error('Service Location has deep relations');
                                    },
                                ),
                            )
                        }
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DeleteServiceLocationAction;
